import { render, staticRenderFns } from "./InscripcionesView.vue?vue&type=template&id=169962fd&scoped=true"
import script from "./InscripcionesView.vue?vue&type=script&lang=js"
export * from "./InscripcionesView.vue?vue&type=script&lang=js"
import style0 from "./InscripcionesView.vue?vue&type=style&index=0&id=169962fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "169962fd",
  null
  
)

export default component.exports